import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_EngAuthorizationToDPHI = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_EngAuthorizationToDPHI' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Authorization to Disclose Protected Health Information (or other confidential information)</h3></center></p>
                <p className='w-750'><center>This authorization complies with the requirements of: Section 164.508 of the HIPAA Privacy Standards <br />(45 CFR, Parts 160 and 164) and
                    Occupations Code § 159.005 - Consent for Release of Confidential Information.</center></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Name:</span>
                            <input type='text' id='txtNameOfClient' name='txttxtNameOfClient' placeholder='(Name of Individual)' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Address:
                            </span>

                            <input type='text' id='txtAddressStreet' name='txtAddressStreet' placeholder='(Street Number, Post Office Box, Route Number)' className='add-only w-350 custom-add-only' />
                            <input type='text' id='txtAddressCity' name='txtAddressCity' placeholder='(City) ' className='add-only w-150 custom-add-only' />
                            <input type='text' id='txtAddressState' name='txtAddressState' placeholder='(State)' className='add-only w-100 custom-add-only' />
                            <input type='text' id='txtAddressZip' name='txtAddressZip' placeholder='(Zip Code)' className='add-only w-100 custom-add-only' />

                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> I authorize the following person or entity:</span>

                            <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' placeholder='(Specify the Individual, Physician, Hospital, Clinic, Attorney, Counselor, School, Governmental entity, etc.)' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtEntityStreet' name='txtEntityStreet' placeholder='(Street Number, Post Office Box, Route Number)' className='add-only w-350 custom-add-only' />
                            <input type='text' id='txtEntityCity' name='txtEntityCity' placeholder='(City) ' className='add-only w-150 custom-add-only' />
                            <input type='text' id='txtEntityState' name='txtEntityState' placeholder='(State)' className='add-only w-100 custom-add-only' />
                            <input type='text' id='txtEntityZip' name='txtEntityZip' placeholder='(Zip Code)' className='add-only w-100 custom-add-only' />

                        </td>
                    </tr>
                </table>

                <p className='w-750'><b><span className='eleHeader'>To disclose the following specific health or other confidential information:</span></b></p>

                <p><input type='radio' id='rbMedicalYes' name='rbMedical' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbMedicalNo' name='rbMedical' className='add-only' value='No' /> No &nbsp;

                    Medical or Health Information. Indicate specific information if limiting:</p>


                <p><input type='radio' id='rbHivYes' name='rbHiv' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbHivNo' name='rbHiv' className='add-only' value='No' /> No &nbsp;

                    HIV-Related Information. Indicate specific information if limiting:</p>


                <p><input type='radio' id='rbPsychologicalYes' name='rbPsychological' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbPsychologicalNo' name='rbPsychological' className='add-only' value='No' /> No &nbsp;

                    Psychological Reports. Indicate specific information if limiting:</p>


                <p><input type='radio' id='rbSocialHistoryYes' name='rbSocialHistory' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbSocialHistoryNo' name='rbSocialHistory' className='add-only' value='No' /> No &nbsp;

                    Social History. Indicate specific information if limiting:</p>


                <p><input type='radio' id='rbCaseManagementYes' name='rbCaseManagement' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbCaseManagementNo' name='rbCaseManagement' className='add-only' value='No' /> No &nbsp;

                    Case Management Records Indicate specific information if limiting:</p>


                <p><input type='radio' id='rbEducationalYes' name='rbEducational' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbEducationalNo' name='rbEducational' className='add-only' value='No' /> No &nbsp;

                    Educational Plan Indicate specific information if limiting:</p>


                <p><input type='radio' id='rbOtherYes' name='rbOther' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbOtherNo' name='rbOther' className='add-only' value='No' /> No &nbsp;

                    Other. Indicate specific information if limiting:</p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> To the following individual or entity:</span>

                            <input type='text' id='txtFollowingIndividual' name='txtFollowingIndividual' placeholder='(Name or position of individual/entity authorized to receive information)' className='add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtFollowingIndividualStreet' name='txtFollowingIndividualStreet' placeholder='(Street Number, Post Office Box, Route Number)' className='add-only w-350 custom-add-only' />
                            <input type='text' id='txtFollowingIndividualCity' name='txtFollowingIndividualCity' placeholder='(City) ' className='add-only w-150 custom-add-only' />
                            <input type='text' id='txtFollowingIndividualState' name='txtFollowingIndividualState' placeholder='(State)' className='add-only w-100 custom-add-only' />
                            <input type='text' id='txtFollowingIndividualZip' name='txtFollowingIndividualZip' placeholder='(Zip Code)' className='add-only w-100 custom-add-only' />

                        </td>
                    </tr>
                </table>

                <p className='w-750'>The information disclosed may be used by the individual/entity receiving the information for the following purpose:
                    <input type='text' id='txtInfoDisclose' name='txtInfoDisclose' className='add-only' />This authorization for release of information will end at the time case management services are discontinued or upon my
                    request.</p>

                <p className='w-750'>This form &nbsp;
                    <input type='radio' id='rbReadByMe' name='rbThisFormRead' className='add-only' value='ReadByMe' /> was read by me&nbsp;
                    <input type='radio' id='rbReadToMe' name='rbThisFormRead' className='add-only' value='ReadToMe' /> &nbsp;
                    was read to me and I understand its purpose and content. All blanks were completed or struck
                    through before I signed the form. <br />
                    I understand that: (1) I may revoke this authorization in writing by contacting the HHSC office or program that obtained the
                    authorization; (2) this authorization will not affect treatment, payment, enrollment, or eligibility for benefits; and (3) information
                    disclosed as a result of this authorization could be subject to re-disclosure as authorized by law.
                </p>

                <table>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Individual or Personal Representative</td> &nbsp;&nbsp;
                        <td className='small w-200'>Date signed</td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>(Print / type name of Personal Representative, state their authority to act on behalf of individual. Attach documents to support.)</td> &nbsp;&nbsp;
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>(Address)</td> &nbsp;&nbsp;
                        <td className='small w-200'>(Telephone)</td>
                    </tr>
                </table>

                <h3 className='w-750'>PRIVACY NOTIFICATION</h3>
                <p className='w-750'>With few exceptions, you have the right to request and be informed about information that the State of Texas collects about you. You are
                    entitled to receive and review the information upon request. You also have the right to ask the state agency to correct any information that is
                    determined to be incorrect. <br />(Reference: <i>Government Code, Sections 552.021, 552.023, 559.003 and 559.004)</i>
                </p>




            </div>
        </form>

    )
}











